import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import footerlogoSrc from "../../Images/Meepl_new_logo with text png.png";
import { ConvertDate } from '../../../Base/helper/baseFunctions';

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        paddingTop: 10,
        paddingBottom: 30,
        paddingHorizontal: 10,
    },
    container: {
        border: "1px solid #bfbfbf",
    },
    addressContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 5,
        borderBottom: "0.5px solid #bfbfbf",
    },
    logoContainer: {
        flex: 1,
        alignItems: 'flex-start',
        marginLeft: 5,
        marginTop: 3
    },
    logo: {
        objectFit: "contain",
        height: 60,
    },
    headerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 2,
        position: 'relative',
        marginBottom: "10px"
    },

    logoContainer1: {
        width: 80,
        alignItems: 'flex-start',
        paddingLeft: 5,
    },
    rightHead: {
        width: 80,
        alignItems: 'flex-start',
    },

    logo1: {
        height: 60,
        objectFit: "contain",
    },

    centeredTextWrapper: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },

    companyNameLabel1: {
        fontSize: 16,
        fontWeight: 900,
        color: "#000",
        textAlign: 'center',
    },
    payslipContainer: {
        flex: 2,
        paddingHorizontal: 10,
        textAlign: "right"
    },
    companyNameLabel: {
        fontSize: 16,
        marginBottom: 2,
        fontWeight: 900,
        color: "#000",
    },
    addressLabel: {
        fontSize: 10,
        color: "#000",
    },
    monthContainer: {
        textAlign: "center",
        paddingBottom: 3,
        paddingTop: 2,
        borderBottom: "0.5px solid #bfbfbf",
    },
    monthLabel: {
        fontSize: 10,
        fontWeight: 900,
        color: "#000",
        textTransform: "uppercase"
    },
    employeeSummaryContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
    },
    column: {
        flex: 1,
        paddingHorizontal: 5,
    },
    row: {
        flexDirection: "row",
        marginTop: 10,
        width: "100%"
    },
    label: {
        fontSize: "8.6px",
        fontWeight: "bold",
        color: "#000",
        width: "50%"
    },
    value: {
        fontSize: "8.6px",
        fontWeight: "bold",
        color: "#000",
        marginLeft: 2,
        width: "50%"
    },
    table: {
        display: 'table',
        width: '100%',
    },
    table1: {
        display: 'table',
        width: '100%',
    },
    tableRow: {
        flexDirection: 'row',

    },
    tableRow1: {
        flexDirection: 'row',
        borderBottom: "0.5px solid #bfbfbf",
        borderTop: "0.5px solid #bfbfbf",
    },
    tableRow11: {
        width: "100%",
        textAlign: "center"
    },
    tableHeader: {
        flexDirection: 'row',
        width: '100%',
    },
    tablesubheader: {
        padding: 6,
        fontSize: "8.6px",
        fontWeight: "extrabold"
    },
    tableCell: {
        padding: 6,
        fontSize: "8.6px",
        color: "#000",
    },
    tableFooter: {
        borderTop: '1px solid #bfbfbf',
        paddingTop: 5,
        fontSize: 10,
        textAlign: 'right',
    },
    totalLabel: {
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    totalValue: {
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    earningsAndDeductionsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingTop: 15,
        width: '100%',
    },
    section: {
        width: '100%',
    },
    subSection: {
        width: "70%"
    },
    sectionTitle: {
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottom: "0.5px solid #bfbfbf",
        borderTop: "0.5px solid #bfbfbf",
        borderRight: "0.5px solid #bfbfbf",
        padding: 5
    },
    sectionTitle1: {
        fontSize: 10,
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottom: "0.5px solid #bfbfbf",
        borderTop: "0.5px solid #bfbfbf",
        padding: 5,
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 30,
        right: 30,
        textAlign: 'center',
        fontSize: 8,
        color: '#000',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',

    },
    footerLogo: {
        height: 15,
        objectFit: "contain",
        marginLeft: 5,
    },
    footer1: {
        position: 'absolute',
        bottom: 10,
        left: 10,
        right: 10,
        textAlign: 'center',
        fontSize: 10,
        color: '#000',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: "1px solid #000",
        paddingTop: "5px",
        marginTop: "10px"
    },
    footerPowered: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: "5px"
    },
});

const ExpenseReportPDF = ({ data, imageUrl, letterHeadData }) => {

    const capitalizeWords = (text) => {
        return text
            ?.toLowerCase()
            ?.split(' ')
            ?.map(word => word.charAt(0)?.toUpperCase() + word?.slice(1))
            ?.join(' ');
    };
   

    const getCurrentDateTime = () => {
        const now = new Date();
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        const formattedDate = now.toLocaleDateString('en-US', options);
        const hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const amPm = hours >= 12 ? 'PM' : 'AM';
        const formattedTime = `${hours % 12 || 12}:${minutes} ${amPm}`;
        return `* ${formattedDate} and ${formattedTime}`;
    };

    return (
        <Document>
            <Page style={styles.page}>
                {(imageUrl || letterHeadData?.letterhead_header) && (
                    <View style={styles.headerContainer} fixed>
                        <View style={styles.logoContainer1}>
                            {imageUrl && (
                                <Image style={styles.logo1} src={imageUrl} />
                            )}
                        </View>
                        <View style={styles.centeredTextWrapper}>
                            {letterHeadData?.letterhead_header && (
                                <Text style={styles.companyNameLabel1}>
                                    {letterHeadData.letterhead_header}
                                </Text>
                            )}
                        </View>
                        <View style={styles.rightHead} />
                    </View>
                )}
                <View style={styles.container}>
                    <View style={styles.monthContainer}>
                        <Text style={styles.monthLabel}>EMPLOYEE EXPENSES FOR THE MONTH OF - {data?.month_year}</Text>
                    </View>
                    <View style={styles.employeeSummaryContainer}>
                        <View style={styles.column}>
                            <View style={styles.row}>
                                <Text style={styles.label}>EMPLOYEE ID</Text>
                                <Text style={styles.value}>: {data?.employee_no}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>NAME</Text>
                                <Text style={styles.value}>: {data?.employee_name}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>GENDER</Text>
                                <Text style={styles.value}>: {data?.gender ? data.gender : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>DESIGNATION</Text>
                                <Text style={styles.value}>: {data?.designation ? data.designation : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>DATE OF JOINING</Text>
                                <Text style={styles.value}>: {data?.doj ? ConvertDate(data.doj) : "NA"}</Text>
                            </View>
                        </View>
                        <View style={styles.column}>
                            <View style={styles.row}>
                                <Text style={styles.label}>BU</Text>
                                <Text style={styles.value}>: {data?.bu ? data.bu : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>UAN</Text>
                                <Text style={styles.value}>: {data?.uan ? data.uan : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>PAN</Text>
                                <Text style={styles.value}>: {data?.pan ? data.pan : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>BANK NAME</Text>
                                <Text style={styles.value}>: {data?.bank_acc_name ? data.bank_acc_name : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>BANK A/C NO.</Text>
                                <Text style={styles.value}>: {data?.bank_acc_no ? data.bank_acc_no : "NA"}</Text>
                            </View>
                            <View style={styles.row}>
                                <Text style={styles.label}>PAY PERIOD</Text>
                                <Text style={styles.value}>: {data?.pay_period ? data.pay_period : "NA"}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={styles.earningsAndDeductionsContainer}>
                        <View style={styles.section}>
                            <Text style={{...styles.sectionTitle1}}>Expenses</Text>
                            <View style={{ flexGrow: 1 }}>
                                <View style={styles.table}>
                                    <View style={{...styles.tableRow, borderBottom: "0.5px solid #bfbfbf"}}>
                                        <Text style={[styles.tablesubheader, { width: '30%'}]}>Category</Text>
                                        <Text style={[styles.tablesubheader, { width: '30%'}]}>Subcategory</Text>
                                        <Text style={[styles.tablesubheader, { width: '20%'}]}>Claimed Date</Text>
                                        <Text style={[styles.tablesubheader, { width: '20%', textAlign: "right"}]}>Approved Amount</Text>
                                    </View>
                                    {data?.expense_json?.map((entry, index) => (
                                        <View style={styles.tableRow} key={index}>
                                            <Text style={[styles.tableCell, { width: '30%' }]}>{capitalizeWords(entry?.expense_name)}</Text>
                                            <Text style={[styles.tableCell, { width: '30%' }]}>{capitalizeWords(entry?.sub_expense_type_name)}</Text>
                                            <Text style={[styles.tableCell, { width: '20%' }]}>{ConvertDate(entry?.["entry date"])}</Text>
                                            <Text style={[styles.tableCell, { width: '20%', textAlign: "right" }]}>
                                                {entry?.finance_approver_amount}
                                            </Text>
                                        </View>
                                    ))}
                                </View>
                            </View>
                            <View style={styles.tableRow1}>
                                <Text style={[styles.tablesubheader, { width: '50%' }]}>Total Expenses</Text>
                                <Text style={[styles.tablesubheader, { width: '50%', textAlign: "right" }]}>
                                    {data?.expenses_reimbursement}
                                </Text>
                            </View>
                        </View>
                    </View>
                    
                    <View style={[styles.tableRow1, { marginTop: 10 }]}>
                        <Text style={[styles.tablesubheader, { width: '35%', fontWeight: 'bold' }]}>
                            Expense Reimbursement Amount : {data?.expenses_reimbursement ||  "000"}
                        </Text>
                        <Text style={[styles.tablesubheader, { width: '15%', textAlign: "left" }]}>
                            
                        </Text>
                        <Text style={[styles.tablesubheader, { width: '50%', fontStyle: "italic" }]}>
                            {`Indian Rupee ${capitalizeWords(toWordsDynamic(Math.floor(data?.expenses_reimbursement || 0)))} Only`}
                        </Text>
                    </View>
                    <View style={styles.tableRow1}>
                        <Text style={[styles.tablesubheader, { width: '30%', textAlign: "left" }]}>{getCurrentDateTime()}</Text>
                        <Text style={[styles.tablesubheader, { width: '60%', fontStyle: "oblique" }]}>Computer generated expense report. Signature not required</Text>
                    </View>
                </View>
                {letterHeadData?.letterhead_footer && (
                    <View style={styles.footer1} fixed>
                        <Text>{letterHeadData?.letterhead_footer}</Text>
                        <View style={styles.footerPowered}>
                            <Text>Powered by</Text>
                            <Image style={styles.footerLogo} src={footerlogoSrc} />
                        </View>
                    </View>
                )}
            </Page>
        </Document>
    );
};

export default ExpenseReportPDF;

 const toWordsDynamic = (num) => {
        if (num === 0) return "Zero";

        const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
            "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];

        const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

        const convert = (n) => {
            if (n < 20) return ones[n];

            if (n < 100) {
                return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "");
            }

            if (n < 1000) {
                return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + convert(n % 100) : "");
            }

            if (n < 100000) {
                return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 !== 0 ? " " + convert(n % 1000) : "");
            }

            if (n < 10000000) {
                return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 !== 0 ? " " + convert(n % 100000) : "");
            }

            return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 !== 0 ? " " + convert(n % 10000000) : "");
        };

        return convert(num);
    };